import { render, staticRenderFns } from "./Spinna.vue?vue&type=template&id=4457d74c&scoped=true&"
import script from "./Spinna.vue?vue&type=script&lang=js&"
export * from "./Spinna.vue?vue&type=script&lang=js&"
import style0 from "./Spinna.vue?vue&type=style&index=0&id=4457d74c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4457d74c",
  null
  
)

export default component.exports